module.exports = __webpack_public_path__ + "static/media/portfolio_site_wald_nektar_1.d7a3e17c.png";